import React, { useEffect, useState } from 'react';
import ErrorWrapper from '@/app/ErrorWrapper';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authApi } from '@/api';
import { notification, Result, Spin } from 'antd';

const ActiveAccountComponent = ({ ...props }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate()
    const token = searchParams.get('token');
    const [loadingActiveAccount, setLoadingActiveAccount] = useState(true);
    const [activeStatus, setActiveStatus] = useState({
        status: 'info',
        description: 'Please wait'
    });

    useEffect(() => {
        authApi
            .activeAccount(token)
            .then(() =>
                setActiveStatus({
                    status: 'success',
                    description: 'Something has occurred'
                })
            )
            .catch((err) =>
                setActiveStatus({
                    status: 'warning',
                    description: 'Something has occurred'
                })
            )
            .finally(() => setLoadingActiveAccount(false));
    }, []);

    useEffect(() => {
        let timer;

        if (activeStatus.status === 'success') {
            timer = setTimeout(() => {
                navigate('/');
            }, 2000);
        }
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [activeStatus]);

    return (
        <div className="w-full h-[100vh] flex items-center justify-center">
            {loadingActiveAccount ? (
                <Spin />
            ) : (
                <Result
                    status={activeStatus.status}
                    title={activeStatus.description}
                />
            )}
        </div>
    );
};

ActiveAccountComponent.displayName = 'ActiveAccount';

const ActiveAccount = (props) => {
    return (
        <ErrorWrapper>
            <ActiveAccountComponent
                data-id="ActiveAccount-cpn"
                {...props}
            />
        </ErrorWrapper>
    );
};

export default ActiveAccount;
